module.exports = __webpack_public_path__ + "static/media/A1_Sports_DRAGON_RED.7b4ae81c.png";